import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, Radio, RadioGroup } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Storage } from 'react-jhipster';
import { translate } from 'react-jhipster';
import { Button } from 'reactstrap';

interface SMSModalProps {
  open: boolean;
  onClose: () => void;
  repurchase: boolean;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: () => void;
  disabled?: boolean;
}

// TODO refactor to reduce input params and move data into internal state where possible
const SmsDialog: React.FC<SMSModalProps> = ({
                                              open,
                                              onClose,
                                              repurchase,
                                              value,
                                              onChange,
                                              onClick,
                                              disabled = false
                                            }) => {
  return (
    <Dialog open={open} onClose={onClose} hidden={repurchase === true}>
      <DialogTitle
        style={{
          width: 300,
          fontWeight: 'bold',
        }}
      >
        {Storage.session.get('locale') === 'en' ? 'SMS Language' : 'لغة الرسائل القصيرة'}
      </DialogTitle>
      <DialogContent style={{ color: 'black' }}>
        <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <RadioGroup aria-label="sms" name="sms" value={value} onChange={onChange}>
          <FormControlLabel value={'EN'} control={<Radio />} label={Storage.session.get('locale') === 'en' ? 'English' : 'إنجليزي'} />
          <FormControlLabel value={'AR'} control={<Radio />} label={Storage.session.get('locale') === 'en' ? 'Arabic' : 'عربي'} />
        </RadioGroup>
      </DialogContent>
      <DialogActions className="mx-3 mb-3">
        <Button onClick={onClose}>{translate('comexApp.quotation.cancelBtnLabel')}</Button>
        &nbsp;
        <Button color="primary" onClick={onClick} autoFocus disabled={disabled}>
          {disabled && <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"/>}
          {translate('comexApp.quotation.confirmButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SmsDialog;
